import React from 'react';

import { Box, TextField } from '@mui/material';

export default function VEColorPicker(props) {

    return (
        <Box className='flex items-center'>
            <TextField 
                onChange={(e) => props.onChange(e.target.value)}
                style={{ width: "100px" }}
                value={props.value}
                variant="standard"
                size="small"
                autoComplete="off"
                // disabled={!props.fieldEnabled}
                // label = {props.inputLabel}
                multiline
                InputProps={{ ...props.inputProps, style: { border: "none", fontFamily: 'monospace', fontSize:"12px" }}} />
            {
                // ((props.value.startsWith("#") && props.value.length === 7) || props.value.length===0) ?
                <input
                type="color"
                value={props.value}
                className="color-picker"
                onChange={(event) => {
                    props.onChange(event.target.value);
                }} />
                // :
                // <Box style={{
                //     backgroundColor: props.value, 
                //     display: "inline-block", 
                //     border: "1px solid #EEE", 
                //     borderRadius: "5px", 
                //     width: "20px", 
                //     height: "16px"}}>

                // </Box>
            
            }
        </Box>
        
    );
};